import { Avatar, AvatarProps, Badge, TooltipProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import Icon from '@ui/Icon';
import StudioClipActionTooltip from '../../../StudioClip/Actions/StudioClipActionTooltip';

export interface AvatarWithFallbackProps extends Omit<AvatarProps, 'children'> {
  isFavorite?: boolean;
  placement?: TooltipProps['placement'];
}

const useStyles = makeStyles()(theme => ({
  heartIcon: {
    position: 'absolute',
    left: 6,
    top: 4,
    zIndex: 1,
  },
}));

const AvatarImage = React.memo((props: AvatarWithFallbackProps) => {
  const { title, placement, ...rest } = props;
  return title ? (
    <StudioClipActionTooltip title={title ?? 'Avatar'} placement={placement}>
      <Avatar {...rest} alt={rest.alt || title || ''}>
        <img
          className="MuiAvatar-img"
          alt={rest.alt || title || ''}
          src="/static/images/product/cta-avatar.svg"
        />
      </Avatar>
    </StudioClipActionTooltip>
  ) : (
    <Avatar {...rest} alt={rest.alt || ''}>
      <img
        className="MuiAvatar-img"
        alt={rest.alt || ''}
        src="/static/images/product/cta-avatar.svg"
      />
    </Avatar>
  );
});

export default React.memo(function AvatarWithFallback(
  props: AvatarWithFallbackProps
) {
  const { classes } = useStyles();
  const { isFavorite, ...rest } = props;

  return isFavorite ? (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={
        <Icon
          type="heartProfile"
          titleAccess="heartProfile"
          className={classes.heartIcon}
          style={{ fontSize: 24 }}
        />
      }
    >
      <Avatar {...rest} alt={rest.alt || ''}>
        <img
          className="MuiAvatar-img"
          alt={rest.alt || ''}
          src="/static/images/product/cta-avatar.svg"
        />
      </Avatar>
    </Badge>
  ) : (
    <AvatarImage {...rest} />
  );
});
